// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyBx4zbj_J2kemZH70PqsUXYTRpFigLTRTA",
    authDomain: "tagoreglobalschoolkuk.firebaseapp.com",
    databaseURL: "https://tagoreglobalschoolkuk-default-rtdb.firebaseio.com",
    projectId: "tagoreglobalschoolkuk",
    storageBucket: "tagoreglobalschoolkuk.appspot.com",
    messagingSenderId: "73719283042",
    appId: "1:73719283042:web:a7118f39231143c277003b",
    measurementId: "G-68NKYSDC0L"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
